import React from 'react';
import Grid from "@mui/material/Grid";

import GeodisStringField from "./GeodisStringField";

function Geodis(props) {
    return (
        <Grid container columnSpacing={2} rowSpacing={2}>
            <Grid item xs={12}>
                <GeodisStringField name={'api_url'} />
            </Grid>
            <Grid item xs={6}>
                <GeodisStringField name={'api_username'} />
            </Grid>
            <Grid item xs={6}>
                <GeodisStringField name={'api_key'} />
            </Grid>
            <Grid item xs={4}>
                <GeodisStringField name={'agency_code'} />
            </Grid>
            <Grid item xs={4}>
                <GeodisStringField name={'client_code'} />
            </Grid>
            <Grid item xs={4}>
                <GeodisStringField name={'product_code'} />
            </Grid>
            <Grid item xs={12}>
                <GeodisStringField name={'sender_name'} />
            </Grid>
            <Grid item xs={4}>
                <GeodisStringField name={'sender_country_code'} />
            </Grid>
            <Grid item xs={4}>
                <GeodisStringField name={'sender_post_code'} />
            </Grid>
            <Grid item xs={4}>
                <GeodisStringField name={'sender_city'} />
            </Grid>
        </Grid>
    );
}

export default Geodis;
